import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { resetPasswordCodeSchema } from '../validation';
import { ResetPasswordFormData, Step } from './types';

export const useResetPasswordForm = () => {
  return useForm<ResetPasswordFormData>({
    // @ts-expect-error - yup resolver type mismatch with react-hook-form
    resolver: yupResolver(resetPasswordCodeSchema),
    mode: 'onChange',
  });
};

export const useCodeInput = (step: Step) => {
  const [code, setCode] = useState<string>('');

  useEffect(() => {
    setCode('');
  }, [step]);

  const handleCodeChange = (otp: string): void => {
    if (otp.length <= 6 && /^\d*$/.test(otp)) {
      setCode(otp);
    }
  };

  const handleCodeKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>): void => {
    if (e.key === 'Backspace' && !code[index] && index > 0) {
      const prevInput = document.querySelector(`input[data-index="${index - 1}"]`) as HTMLInputElement;
      prevInput?.focus();
    }
  };

  return { code, handleCodeChange, handleCodeKeyDown };
};
